module.exports = __webpack_public_path__ + "img/brand_krups.330788f5.webp";